export default () => {
  const body = document.body;
  const $header = $('header#header');
  const header = $header[0];
  const $navicon = $('#navicon');
  const navicon = $navicon[0];
  const $sideBar = $('.side-bar');
  const sideBar = $sideBar[0];
  let padding = -1;

  $('.modal')
    .on('show.bs.modal', () => {

      if (padding === -1)
      {
        setTimeout(() => {
          padding = parseFloat(body.style.paddingRight || 0);

          adjustPadding();
        }, 1);

        return;
      }

      adjustPadding();
    })
    .on('hidden.bs.modal', () => {
      if (sideBar)
      {
        sideBar.style.right = '';
      }

      if (header)
      {
        header.style.paddingRight = '';
      }

      if (navicon)
      {
        navicon.style.marginLeft = '';
        setTimeout(() => {
          navicon.style.transition = navicon.style['-webkit-transition'] = '';
        });
      }
    });

  function adjustPadding() {
    if (sideBar)
    {
      sideBar.style.right = `${padding}px`;
    }

    if (header)
    {
      header.style.paddingRight = `${padding}px`;
    }

    if (navicon)
    {
      navicon.style.transition = navicon.style['-webkit-transition'] = 'none';
      navicon.style.marginLeft = `${-padding / 2}px`;
    }
  }
}
